<template>
  <div>
    <table-filter v-model="filter" :columns="columns"/>
    <div class="row justify-between">
      <div></div>
      <q-table-columns
          color="secondary"
          class="q-mr-sm"
          style="width: 100px;"
          v-model="visibleColumns"
          :columns="columns"
      />
    </div>
    <h-table
        :data='data'
        row-key="label"
        :columns='columns'
        :visible-columns="visibleColumns"
        :filter="filter"
        :pagination.sync="serverPagination"
        :rows-per-page-options="perPageOptions"
        :loading="loading"
        ref="table"
        @request="fetchTransactions"
    >
      <q-td
          slot="body-cell-edit"
          slot-scope="props"
          class="text-right"
      >
        <q-btn
            v-if=""
            @click="editTransaction(props.row)"
            :disable="!canEdit()"
            icon="edit"
            color="tertiary"
            class="hover-primary"
            flat
            round
        >
          <q-tooltip
              :delay="500"
              :offset="[0, 5]"
          >
            Редактировать
          </q-tooltip>
        </q-btn>

        <q-btn
            v-if="transactionIsIncome(props.row)"
            @click="deleteTransaction(props.row)"
            :disable="!canEdit()"
            icon="delete"
            color="tertiary"
            class="hover-negative"
            flat
            round
        >
          <q-tooltip
              :delay="500"
              :offset="[0, 5]"
          >
            Удалить
          </q-tooltip>
        </q-btn>
      </q-td>
    </h-table>

    <q-modal
        v-model="transactionOpened"
        @show="$refs.realAmountInput.focus()"
        content-css="width: 400px;"
    >
      <div class="q-pa-lg bill">
        <q-field>
          <q-input
              ref="realAmountInput"
              v-model="transaction.realAmount"
              @keyup.enter="updateTransaction"
              stack-label="Сумма"
          />
        </q-field>
      </div>
      <div class="row justify-end q-pa-lg">
        <q-btn
            :loading="saving"
            @click="updateTransaction"
            color="primary"
            class="q-mr-xs"
            label="Сохранить"
        />

        <q-btn
            @click="transactionOpened = false"
            color="primary"
            flat
            label="Отмена"
        />
      </div>
    </q-modal>

    <!--    <q-modal
            @show="$refs.chargeTransactionInput.focus()"
            v-model="chargeTransactionOpened"
            content-css="width: 400px;"
        >
          <div class="q-pa-lg bill">
            Регистрация расхода
            <q-field>
              <q-input
                  ref="chargeTransactionInput"
                  v-model="newTransaction.amount"
                  @keyup.enter="chargeTransaction"
                  stack-label="Сумма"
                  type="number"
              />
            </q-field>
          </div>
          <div class="row justify-end q-pa-lg">
            <q-btn label="Отмена" style="margin-right: 10px;" @click="chargeTransactionOpened=false"/>
            <q-btn label="Сохранить" color="primary" @click="chargeTransaction"/>
          </div>
        </q-modal>

        <q-modal
            v-model="incomeTransactionOpened"
            @show="$refs.incomeTransactionInput.focus()"
            content-css="width: 400px;"
        >
          <div class="q-pa-lg bill">
            Регистрация прихода
            <q-field>
              <q-input
                  ref="incomeTransactionInput"
                  v-model="newTransaction.amount"
                  stack-label="Сумма"
                  type="number"
                  @keyup.enter="createTransaction"
              />
            </q-field>
          </div>
          <div class="row justify-end q-pa-lg">
            <q-btn label="Отмена" style="margin-right: 10px;" @click="incomeTransactionOpened=false"/>
            <q-btn label="Сохранить" color="primary" @click="createTransaction"/>
          </div>
        </q-modal>

        <div>
          <q-btn label="Приход" :disable=!canEdit() icon="add" color="positive" @click="incomeTransactionOpened=true"/>
          <q-btn label="Расход" :disable=!canEdit() icon="remove" color="negative" @click="chargeTransactionOpened=true"/>
        </div>-->
  </div>
</template>

<script>
import HTable from '@/HTable'
import HTh from '@/HTh'
import TableFilter from '@/TableFilter'
import columnsValues from '@/HTable/columnsValues'

import tableHelpers from 'components/HTable/helpers'
import api from 'mixins/api'
import makeCorrectAmount from 'mixins/makeCorrectAmount'

import {
  QBtn,
  QField,
  QIcon,
  QInput,
  QModal,
  QPopover,
  QSelect,
  QTable,
  QTableColumns,
  QTd,
  QTh,
  QTooltip,
  QTr,
} from 'quasar'

export default {
  name: 'TransactionsList',

  components: {
    HTable,
    HTh,
    QField,
    QInput,
    QSelect,
    QBtn,
    QIcon,
    QTable,
    QTableColumns,
    QTr,
    QTh,
    QTd,
    QPopover,
    QModal,
    QTooltip,
    TableFilter,
  },

  mixins: [
    tableHelpers,
    api,
    makeCorrectAmount,
  ],

  props: {
    userId: String,
  },

  data () {
    return {
      columns: [
        {
          label: 'ID',
          field: 'id',
          name: 'transactions.id',
          sortable: true,
          filter: '',
          type: 'text',
          align: 'left',
        },
        {
          label: 'Номер счёта',
          field: 'bill_number',
          name: 'number',
          sortable: true,
          filter: '',
          type: 'text',
          align: 'left',
        },
        {
          label: 'Сумма',
          field: 'amount',
          name: 'transactions.amount',
          sortable: true,
          type: '',
          filter: '',
          align: 'left',
          format: val => {
            val = val / 100

            return this.resolveAmount(val)
          },
        },
        {
          label: 'Тип',
          field: 'type',
          name: 'type',
          sortable: true,
          filter: [],
          type: 'value',
          values: columnsValues.transactionType,
          align: 'left',
        },
        {
          label: 'Дата создания',
          field: 'created_at',
          name: 'created_at',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Действия',
          name: 'edit',
          field: 'id',
          sortable: false,
          align: 'right',
        },
      ],
      //visibleColumns: ['first_name', 'last_name', 'email', 'role', 'edit'],
      data: [],

      loading: false,

      perPageOptions: [10, 20, 40, 60],

      visibleColumns: this.getVisibleColumns() || ['id', 'bill_number', 'amount', 'type', 'created_at'],

      filterCols: {},

      incomeTransactionOpened: false,

      chargeTransactionOpened: false,

      saving: false,

      transactionOpened: false,

      transaction: {
        realAmount: null,
      },

      newTransaction: {
        amount: null,
      },
    }
  },

  mounted () {
    this.fetchTransactions({
      pagination: this.serverPagination,
      filter: this.filter,
    })
  },

  methods: {
    fetchTransactions ({ pagination, filter }) {
      this.loading = true
      this.query = this.getQuery(pagination, filter)
      this.api.get(`users/${ this.$route.params.id }/transactions/${ this.query }`).then((response) => {
        if (this.verifyResponse(response)) {
          this.updatePagination(pagination, response.data.total)
          this.updateData(response.data.transactions)
        }
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.loading = false
      })
    },

    chargeTransaction () {
      let transaction = {
        amount: -this.formatNumber(this.newTransaction.amount, 100),
      }

      this.chargeTransactionOpened = false
      this.$http.post(`/api/v1.0/users/${ this.$route.params.id }/transactions/charge`, transaction).then(response => {
        this.fetchTransactions({
          pagination: this.serverPagination,
          filter: this.filter,
        })
        this.$q.notify({ message: 'Сохранено', type: 'positive' })
      }).catch(error => {
        console.error(error.response.data.message)
        this.$q.notify({ message: 'Ошибка', type: 'negative' })
      })
    },

    incomeTransaction () {
      let transaction = {
        amount: this.formatNumber(this.newTransaction.amount, 100),
      }

      this.incomeTransactionOpened = false
      this.$http.post(`/api/v1.0/users/${ this.$route.params.id }/transactions/income`, transaction).then(response => {
        this.fetchTransactions({
          pagination: this.serverPagination,
          filter: this.filter,
        })
        this.$q.notify({ message: 'Сохранено', type: 'positive' })
      }).catch(error => {
        console.error(error.response.data.message)
        this.$q.notify({ message: 'Ошибка', type: 'negative' })
      })
    },

    canEdit () {
      return this.$auth.user().role === 'root' || this.$auth.user().role === 'accountant'
    },

    editTransaction (data) {
      this.transactionOpened = true
      data.realAmount = data.amount / 100
      Object.assign(this.transaction, data)
    },

    updateTransaction () {
      this.transactionOpened = false
      this.$http.post(`/api/v1.0/users/${ this.$route.params.id }/transactions/changeTransactionAmount`,
          this.transaction).then(response => {
        this.fetchTransactions({
          pagination: this.serverPagination,
          filter: this.filter,
        })
        this.$q.notify({ message: 'Сохранено', type: 'positive' })
      }).catch(error => {
        console.error(error.response.data.message)
        this.$q.notify({ message: 'Ошибка', type: 'negative' })
      })
    },

    deleteTransaction (transaction) {
      this.$http.delete(`/api/v1.0/users/${ this.$route.params.id }/transactions/delete`, {
        params: {
          transactionId: transaction.id,
        },
      }).then(response => {
        this.fetchTransactions({
          pagination: this.serverPagination,
          filter: this.filter,
        })

        this.$q.notify({ message: 'Транзакция удалена', type: 'positive' })
      }).catch(e => {
        console.error(e.response.data.message)

        this.$q.notify({ message: 'Ошибка', type: 'negative' })
      })
    },

    transactionIsIncome (transaction) {
      return transaction.type === 'INCOME'
    },
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TransactionsList/TransactionsList.vue